import { render, staticRenderFns } from "./MessageReactions.vue?vue&type=template&id=51e307b7&scoped=true"
import script from "./MessageReactions.vue?vue&type=script&lang=js"
export * from "./MessageReactions.vue?vue&type=script&lang=js"
import style0 from "./MessageReactions.vue?vue&type=style&index=0&id=51e307b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e307b7",
  null
  
)

export default component.exports